import L from "leaflet";

export function createMeetupDivIcon(pin, { highlighted = false } = {}) {
  const label = (pin.name || "").split("—")[0].trim().slice(0, 20);
  const pulse = highlighted ? "meetup-geo-pin-pulse meetup-geo-pin-pulse-fast" : "meetup-geo-pin-pulse";
  const body = highlighted ? "meetup-geo-pin-body meetup-geo-pin-body-active" : "meetup-geo-pin-body";
  return L.divIcon({
    className: "meetup-geo-pin",
    html: `<div class="meetup-geo-pin-inner">
      <span class="${pulse}"></span>
      <span class="${body}">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
        <span class="meetup-geo-pin-label">${label}</span>
      </span>
    </div>`,
    iconSize: [128, 36],
    iconAnchor: [64, 18],
    popupAnchor: [0, -20],
  });
}

export const MEETUP_MAP_CSS = `
  .meetup-geo-pin { background: transparent; border: none; }
  .meetup-geo-pin-inner { position: relative; display: inline-flex; }
  .meetup-geo-pin-pulse {
    position: absolute; inset: -8px; border-radius: 9999px;
    background: rgba(34, 211, 238, 0.35); animation: meetup-ping 1.8s ease-out infinite;
  }
  .meetup-geo-pin-pulse-fast { animation-duration: 1.1s; background: rgba(251, 146, 60, 0.45); }
  @keyframes meetup-ping {
    0% { transform: scale(0.85); opacity: 0.9; }
    100% { transform: scale(1.4); opacity: 0; }
  }
  .meetup-geo-pin-body {
    position: relative; display: inline-flex; align-items: center; gap: 6px;
    border-radius: 9999px; background: #020617; color: #fff; padding: 8px 12px;
    font-size: 11px; font-weight: 600; box-shadow: 0 10px 25px rgba(15,23,42,0.35);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  .meetup-geo-pin-body-active {
    transform: scale(1.06);
    box-shadow: 0 12px 28px rgba(8, 145, 178, 0.45);
    outline: 2px solid rgba(34, 211, 238, 0.65);
  }
  .meetup-geo-pin-label { max-width: 92px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .meetup-map-skeleton {
    background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
    background-size: 200% 100%;
    animation: meetup-shimmer 1.2s ease-in-out infinite;
  }
  @keyframes meetup-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
`;
